import React from 'react';
import { Toast } from './Toast';
import { ToastProps } from '../../types/toast';

interface ToastContainerProps {
  toasts: ToastProps[];
  onClose: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <div
      aria-live="assertive"
      className="fixed inset-x-0 top-0 flex items-start justify-center px-4 pointer-events-none z-50"
    >
      <div className="w-full max-w-md flex flex-col items-center space-y-3">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            type={toast.type}
            message={toast.message}
            onClose={onClose}
            duration={toast.duration}
          />
        ))}
      </div>
    </div>
  );
};